"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinkColor = void 0;
const getLinkColor = color => {
  if (!color) {
    return "#0d6aa8";
  }
  let navLinkColor;
  if (color === "#363545" || color === "#000000" || color === "#242D2F") {
    navLinkColor = "#0d6aa8";
  } else {
    navLinkColor = color;
  }
  return navLinkColor;
};
exports.getLinkColor = getLinkColor;